import styled, { createGlobalStyle } from "styled-components";

export const Root = styled.div`
  iframe {
    width: 100vw;
    height: 100vh;
    border: none;
  }
`
